<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发布更新</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel mt-20" style="min-height: 500px">
      <h5>版本信息</h5>
      <el-button
        type="primary"
        class="mt-10 mb-20"
        size="small"
        @click="handleDeploy(2)"
        >版本更新</el-button
      >
      <div v-html="versionLog"></div>
    </div>
  </div>
</template>

<script>
import { serverDeploy } from '@/service/getData'
import store from '@/store/store'

export default {
  data() {
    return {
      versionLog: '',
    }
  },
  created() {
    const userInfo = store.state.userInfo
    if (userInfo.id != 1) {
      this.$router.push('/dashboard')
    } else {
      //获取日志
      this.handleDeploy(1)
    }
  },
  methods: {
    async handleDeploy(t = 0) {
      let res = await serverDeploy({
        option_type: t,
      })
      if (res.code == 0) {
        if (t == 1) {
          this.versionLog = res.data.replaceAll('\n', '<br>')
        } else {
          const _this = this
          this.$alert('更新请求已提交', '提示', {
            confirmButtonText: '确定',
            callback: (action) => {
              _this.handleDeploy(1)
            },
          })
        }
      }
    },
  },
}
</script>